import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
export function useRouterEvents(): RouterNavigationEvents {
  const [transitioning, setTransitioning] = useState(false);
  const router = useRouter();
  useEffect(() => {
    const routeChangeStartHandler = () => {
      setTransitioning(true);
    };

    const routeChangeCompleteHandler = () => {
      setTransitioning(false);
    };

    router.events.on('routeChangeStart', routeChangeStartHandler);
    router.events.on('routeChangeComplete', routeChangeCompleteHandler);
    return () => {
      router.events.off('routeChangeStart', routeChangeStartHandler);
      router.events.off('routeChangeComplete', routeChangeCompleteHandler);
    };
  }, []);
  return {
    transitioning,
  };
}
